import React, { FC } from 'react';
import { Badge } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';

type Props = {};

const CommentsTextEditorReworkBadge: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="tw-relative tw-h-full tw-w-0">
      <Badge className="tw-absolute tw-left-6 tw-top-0 tw-z-10 -tw-translate-y-1/2 tw-bg-danger-100 tw-text-white">
        {t('rework')}
      </Badge>
    </div>
  );
};

export default CommentsTextEditorReworkBadge;
